export const MainContent = ( {children} ) => (
  <div className="main-content">
    { children }
  </div>
);
